let en = {
  translations: {
    home: {
      installer: "Installer",
      support: "Support",
      customer: "Customer",
      admin: "Admin",
    },
    login: {
      title: "Sign in",
      username: "Username",
      password: "Password",
      button: "Sign in Now",
      have_account: "Have an account? ",
      sign_in: "Sign in",
      swipe_text: "Swipe to unlock",
      swipe_text_unlocked: "Unlocked",
      errors: {
        user_required: "Email is required",
        password_required: "Password is required",
      },
    },
    reset: {
      title: "Reset Password",
      email: "Email",
      username: "Username",
      button: "Send reset link",
      dont_remember_password: "Don't remember password? ",
      reset: "Reset",
      text: "Enter the username associated with your account, and we’ll email you a link to reset your password.",
      message:
        "A link to reset your password has been sent to your email address.",
      username_does_not_exist: "Username does not exist",
    },
    reset_confirm: {
      title: "Update Password",
      password: "Password",
      confirm_password: "Confirm Password",
      button: "Update",
      text: "",
      message: "Welcome back! Your password has been updated.",
      errors: {
        password_mismatch: "password mismatch",
        wrong_password: "Wrong Password",
      },
    },
    register: {
      tabs: {
        installer: "Installer",
        customer: "Customer",
      },
      title: "Create new account",
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email",
      username: "Username",
      password: "Password",
      confirm_password: "Confirm Password",
      telephone_number: "Phone",
      cellular_number: "Mobile",
      fax_number: "Fax",
      street: "Street",
      city: "City",
      cap: "Cap",
      district: "District",
      country: "Country",
      vat_number: "Vat",
      button: "Sign in Now",
      address_title: "Address",
      password_title: "Password",
      contact_title: "Contact",
      account_title: "Account",
      profile_title: "Profile",
      dont_have_account: "Don't have an account? ",
      sign_up: "Sign Up",
      title_edit_address: "Edit Address",
      title_edit_profile: "Edit Profile",
      title_edit_contacts: "Edit Contacts",
      terms_and_conditions: "I accept Eklok sales contract",
      terms_and_conditions_link:
        "https://www.ecat.it/src/html/doc/contratto_eklok_eng.pdf",
      button_save: "Save",
      errors: {
        required: "Is required",
        invalid_email: "Must be a valid email",
      },
      success: {
        title: "Success",
        message: "Congratulations, your account has been successfully created.",
      },
    },
    support: {
      create_support: "Create Support",
    },
    profile: {
      change_password: {
        title: "Change Password",
        current_password: "Current Password",
        new_password: "New Password",
        confirm_password: "Confirm Password",
        button: "Save",
        errors: {
          password_mismatch: "password mismatch",
          wrong_password: "wrong password",
        },
      },
      update: "UPDATE",
    },
    installations: {
      add: "Add Plant",
    },
    nav_menu: {
      home: "HOME",
      reserved_area: "RESERVED AREA",
      link_reserved_area: "https://www.ecat.it/en/reserved-area/",
      link_home: "https://www.ecat.it/en/",
      products: "PRODUCTS",
      link_products: "https://www.ecat.it/en/products/",
      gallery: "GALLERY",
      link_gallery: "https://www.ecat.it/en/gallery/",
      support: "SUPPORT",
      link_support: "https://www.ecat.it/en/support/",
      contact_us: "CONTACTS US",
      link_contact_us: "https://www.ecat.it/en/contacts/",
    },
    nav_menuburger: {
      home: "Home",
      reserved_area: "Reserved Area",
      products: "Products",
      gallery: "Gallery",
      support: "Support",
      contact_us: "Contact Us",
      link_reserved_area: "https://www.ecat.it/en/reserved-area/",
      link_home: "https://www.ecat.it/en/",
      link_products: "https://www.ecat.it/en/products/",
      link_gallery: "https://www.ecat.it/en/gallery/",
      link_support: "https://www.ecat.it/en/support/",
      link_contact_us: "https://www.ecat.it/en/contacts/",
    },
    detail_support: {
      edit_profile: "Edit Profile",
      edit_address: "Edit Address",
      edit_contacts: "Edit Contacts",
      delete_profile: "Delete support",
      address: {
        country: "Country",
        district: "District",
        city: "City",
        street: "Street",
        cap: "Cap",
      },
      contacts: {
        mobile_phone: "Mobile Phone",
        telephone: "Telephone",
        vat_number: "Vat Number",
      },
      user: {
        first_name: "First Name",
        last_name: "Last Name",
        email: "Email",
      },
    },
    delete_support: {
      title: "Elimina supporto",
      text: "Sei sicuro di voler eliminare questo supporto?",
      button_text: "Conferma",
      success_text: "Il supporto è stato eliminato con successo",
    },
    detail_customer: {
      edit_profile: "Edit Profile",
      edit_address: "Edit Address",
      edit_contacts: "Edit Contacts",
      delete_profile: "Delete Customer",
      address: {
        country: "Country",
        district: "District",
        city: "City",
        street: "Street",
        cap: "Cap",
      },
      contacts: {
        mobile_phone: "Mobile Phone",
        telephone: "Telephone",
        vat_number: "Vat Number",
      },
      user: {
        first_name: "First Name",
        last_name: "Last Name",
        email: "Email",
      },
    },
    delete_customer: {
      title: "Elimina Customer",
      text: "Sei sicuro di voler eliminare questo customer?",
      button_text: "Conferma",
      success_text: "Il customer è stato eliminato con successo",
    },
    detail_installer: {
      edit_profile: "Edit Profile",
      edit_address: "Edit Address",
      edit_contacts: "Edit Contacts",
      delete_profile: "Delete Installer",
      contacts: {
        mobile_phone: "Mobile Phone",
        telephone: "Telephone",
        vat_number: "Vat Number",
      },
      address: {
        country: "Country",
        district: "District",
        city: "City",
        street: "Street",
        cap: "Cap",
      },
      user: {
        first_name: "First Name",
        last_name: "Last Name",
        email: "Email",
        id_installer: "ID Installer",
      },
    },
    delete_installer: {
      title: "Delete Installer",
      text: "Are you sure you want to delete this installer?",
      button_text: "Confirm",
      success_text: "The installer has been successfully deleted",
    },
    customer_card: {
      title: "CUSTOMERS",
      action: " VIEW ALL",
      not_active: "Not Active",
      active: "Active",
    },
    ekloks_card: {
      title: "EKLOKS",
      action: " VIEW ALL",
      error: "Error",
      not_connected: "Not Connected",
      connected: "Connected",
    },
    installer_card: {
      title: "INSTALLERS",
      action: " VIEW ALL",
      not_active: "Not Active",
      active: "Active",
    },
    support_card: {
      title: "SUPPORT",
      action: " VIEW ALL",
      not_active: "Not Active",
      active: "Active",
    },
    plant_card: {
      title: "PLANTS",
      action: " VIEW ALL",
    },
    footer: {
      privacy_policy: "Privacy policy",
      cookies_policy: "Cookies policy",
      certification: "ISO Certification",
      company_policy: "Company policy",
      condition: "Warranty and condition",
      sales_contract: "EKlok sales contract",
      return_policy: "Return Policy",
      link_privacy_policy: "https://www.ecat.it/en/privacy-policy/",
      link_cookies_policy: "https://www.ecat.it/en/cookie/",
      link_certification: "https://www.ecat.it/src/html/doc/9001_Inglese.pdf",
      link_company_policy: "https://www.ecat.it/en/company_policy/",
      link_condition: "https://www.ecat.it/src/html/doc/sale_conditions.pdf",
      link_sales_contract:
        "https://www.ecat.it/src/html/doc/contratto_eklok_eng.pdf",
      link_return_policy:
        "https://www.ecat.it/src/html/doc/return_policy_eng.pdf",
    },
    not_found: {
      error_404: "404: The page you are looking for isn’t here",
      description:
        "You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation",
    },
    heads_list_installers: {
      name: "Name",
      email: "Email",
      username: "Username",
      country: "Country",
      city: "City",
      last_update: "Last update",
      connected: "Connected",
      alarms: "Alarms",
      mobile: "Mobile",
      actions: "Actions",
      connect: "Connect",
    },
    heads_list_customers: {
      name: "Name",
      email: "Email",
      username: "Username",
      country: "Country",
      city: "City",
      mobile: "Mobile",
      actions: "Actions",
    },
    heads_list_supports: {
      name: "Name",
      email: "Email",
      username: "Username",
      country: "Country",
      city: "City",
      mobile: "Mobile",
      actions: "Actions",
    },
    heads_list_ekloks: {
      name: "Name",
      hw: "HW",
      serial: "Serial",
      HMI: "HMI",
      SW: "SW",
      last_update: "Last update",
      connected: "Connected",
      alarms: "Alarms",
      actions: "Actions",
    },
    edit_eklok: {
      title: "Edit Eklok",
      name: "Name",
      serial_id: "Serial ID",
      hw_id: "HW ID",
      hmi_version: "HMI Version",
      software_version: "Software Version",
      model_type: "Model Type",
      save: "Save",
    },
    pair_eklok: {
      serial_id: "Serial ID",
      save: "Save",
      notice: {
        title:
          "Make sure you are logged in to your Eklok account before proceeding",
        login_text: "Login Eklok",
        enter_text: "Enter Serial ID",
        confirm_text: "Confirm and activate",
        confirm_button: "Ok",
      },
    },
    active_eklok: {
      generate_code: "Generate Code",
      generate_otp_code: "Generate OTP code",
    },
    create_eklok: {
      title: "Create Eklok",
      name: "Name",
      serial_id: "Serial ID",
      save: "Save",
    },
    create_support: {
      title: "Create new support",
      first_name: "First name",
      last_name: "Last name",
      email: "Email",
      username: "Username",
      password: "Password",
      confirm_password: "Confirm password",
      telephone_number: "Telephone number",
      cellular_number: "Phone number",
      fax_number: "Fax number",
      street: "Street",
      city: "City",
      cap: "Postal code",
      district: "District",
      country: "Country",
      save: "Save",
      success: "User created successfully",
    },
    create_plant: {
      name: "Name",
      country: "Country",
      district: "District",
      city: "City",
      cap: "Cap",
      street: "Street",
      save: "Save",
    },
    device_frame: {
      timeout: "Connection time expired",
    },
    mobile_frame: {
      home: {
        favorites: "Favorites",
        routines: "Routines",
        musics: "Tracks",
        musicsSynth: "Synth tracks",
        dialCorrection: "Dial Correction",
        melodies: "MP3",
        assistance: "Assistance",
        success: "Operation performed successfully",
        stopAll: "Stop all actions",
        details: "Details",
        eklok_name: "Eklok name:",
        action_type: "Action type:",
        action_name: "Action name:",
        action_description: "Description:",
        play_now: "Play now",
        playing: "Now playing",
        seconds: "to left",
        duration: "Duration:",
        view_all_event: "View all actions",
        running_events: "Running actions",
        no_running_events: "There are no ongoing actions",
        no_action_present: "There are no actions present",
        finished: "Terminato",
        blocks_sounds: "Blocks sounds",
        allow_all: "Allow all",
        only_sounds_and_hours: "Only hour ringing",
        deny_all: "Block all",
        select_new_configuration: "Select new configuration",
        current_configuration: "Current configuration",
        support_address: "Address:",
        support_company: "Business name:",
        support_mail: "Email:",
        support_phone: "Phone:",
        support_website: "Web site:",
        installer_data: "Installer data",
        calendar_event: "Events Calendar",
      },
    },
    alarms_eklok: {
      ALARM_USB_INVALID: "Invalid USB",
      ALARM_CPU_HIGH: "CPU usage",
      ALARM_MEMORY_HIGH: "Memory usage",
      ALARM_KBWRUTEDISK_HIGH: "Disc writing",
      ALARM_KBREADDISK_HIGH: "Disc reading",
      ALARM_STORAGEROOT_HIGH: "Root partition write",
      ALARM_STORAGETMPFS_HIGH: "Write temporary filesystem",
      ALARM_SERVICE_EXPIRED: "Expired maintenance",
      ALARM_SW_WD_EXPIRED: "Watchdog expired",
      ALARM_BATTERY_REMOVED: "Battery removed",
      ALARM_DIAL_ERROR: "Dial in error",
      ALARM_AUTO_TIME_INVALID: "Invalid automatic time",
      ERRORE_MODULO_INDIRIZZO: "Module error address",
      ALARM_BATTERY_FAULT: "Battery malfunction",
      ALARM_CONNECTION_MODEM_ISSUE: "Unable to automaticaly connect the modem",
      POWER_DISCONNECTED: "Power disconnected",
      RTC_INVALID: "RTC invalid",
    },
    edit_eklok_reley: {
      title: "Relay",
      name: "Relay",
      value: "Value",
      save: "Save",
    },
    errors: {
      mqtt_action_error_timeout:
        "A communication error has occurred. Error code 60002",
      mqtt_action_no_data: "An error has occurred. Error code 60003",
      mqtt_action_wrong_format_data: "An error has occurred. Error code 60004",
      mqtt_action_error: "An error has occurred. Error code 60005",
      user_disabled: 'Account disabled. Please contact support.',
      installer_cannot_be_deleted:
        "Operation not allowed, check the Plants section",
      customer_cannot_be_deleted: "Operation not allowed",
      http_400: "Invalid request.",
      http_401: "Invalid credentials.",
      http_403: "You do not have permission to perform this action.",
      http_404: "Resource not found.",
      http_409: "Conflict with the current state of the resource.",
      http_422: "The submitted data is invalid.",
      http_429: "Too many requests. Please try again shortly.",
      http_500: "Internal server error. Please try again later.",
      http_502: "Server unreachable. Please try again later.",
      http_503: "Service temporarily unavailable.",
      http_504: "Server timeout. Please try again later.",
      wrong_password: "The password you entered is incorrect.",
      network: "Unable to reach the server. Check your connection.",
      unknown: "An unexpected error has occurred.",
    },
    statuses: {
      connected: "connected",
      unconnected: "disconnected",
      loading: "loading...",
    },
    tooltip_titles: {
      refresh: "Refresh",
      connect: "Connect",
      details: "Detail",
    },
    details_modal: {
      plant_details: "PLANT DETAILS",
      created_by: "Created by",
      location: "Location",
      updated_by: "Updated by",
      info: "Info",
      activity: "Activity",
      edit_plant: "Edit Plant",
      delete_plant: "Delete Plant",
      plant_user: "User",
      plant_email: "Email",
      plant_id: "Plant ID",
      plant_country: "Country",
      plant_district: "District",
      plant_city: "City",
      plant_street: "Street",
      plant_cap: "Cap",
      plant_date: "Date",
      device_title: "DEVICE DETAILS",
      module_status: "MODULE STATUS",
      edit_eklok: "Edit Eklok",
      delete_eklok: "Delete Eklok",
      connect_eklok: "Connect Eklok",
      generate_code: "Generate code",
      generate_otp_code: "Generate OTP code",
      eklok_name: "Name",
      eklok_hmi_version: "HMI Version",
      eklok_hw_id: "HW ID",
      eklok_serial_id: "Serial ID",
      eklok_middleware_version: "Middleware version",
      eklok_software_version: "Software version",
      eklok_model_type: "Model Type",
      activity_connected: "Connected state",
      modules_tooltip_name: "NAME",
      modules_tooltip_percentage: "PERCENTAGE",
      modules_tooltip_hits: "HITS",
      modules_tooltip_usage_time: "USAGE TIME",
      modules_tooltip_type: "TYPE",
      alarms_title: "Alarms",
      alarms_code: "Code",
      alarms_status: "Status",
      alarms_time: "Time",
      alarms_status_active: "ACTIVE",
      alarms_status_inactive: "INACTIVE",
    },
    create_plant_modal: {
      title: "Create Plant",
      step_create_plant: "Create Plant",
      step_create_eklok: "Create Eklok",
      step_gen_active_key: "Generate Activation key",
    },
    table: {
      search: "Search",
      rows_per_page: "Rows per page",
      prev_page: "Previous page",
      next_page: "Next page",
    },
    calendar_event: {
      select_date: "Select a Date:",
      add_new_event: "New Event",
      no_events_in_list: "No events available",
      confirm_dialog_title: "Confirm cancellation",
      confirm_dialog_message: "Do you want to proceed with the cancellation?",
      confirm_button: "Confirm",
      cancel_button: "Cancel",
    },
    calendar_event_item: {
      delete: "Delete",
      from: "From",
      to: "To",
    },
    create_calendar_event: {
      name_label: "Name*",
      description_label: "Description*",
      date_and_time_label: "Date and Time*",
      actions_label: "Actions*",
      select_actions: "Select actions",
      add_event: "Add Event",
      required_field: "Required field",
    },
    action_type: {
      MUSICS: "TRACKS",
      MELODIES: "MP3",
      MUSICS_SYNTH: "SYNTH TRACKS",
      ACTIONS: "ROUTINES",
    },
  },
};

export default en;
